import { ChangeEvent, useState } from 'react';
import { INITIAL_CONSENTS, REQUIRED_CONSENTS } from './components/ConsentsList/constants';
import { ConsentKeys } from '../../../types/consents';

export const useLoginConsents = () => {
	const [checkedConsents, setCheckedConsents] =
		useState<Record<ConsentKeys, boolean>>(INITIAL_CONSENTS);

	const isAllRequiredChecked = REQUIRED_CONSENTS.reduce(
		(acc, id) => acc && checkedConsents[id],
		true,
	);

	const onCheckboxChanged = (isChecked: boolean, event: ChangeEvent<HTMLInputElement>) => {
		setCheckedConsents(prev => ({
			...prev,
			[event.target.name]: isChecked,
		}));
	};

	return {
		checkedConsents,
		onCheckboxChanged,
		setCheckedConsents,
		isAllRequiredChecked,
	};
};
